import { Reducer } from 'redux';
import { ChargePackageActionTypes, ChargePackageStateInterface } from "./types";

export const initialState: ChargePackageStateInterface = {
    info: {},
    loading: false,
    type: 1,
    status: ""
}

const reducer: Reducer<ChargePackageStateInterface> = (state = initialState, action) => {
    switch (action.type) {
        case ChargePackageActionTypes.FETCH_CHARGE_PACKAGE_TYPES: {
            return { ...state, loading: true }
        }
        case ChargePackageActionTypes.SET_CHARGE_PACKAGE_TYPES: {
            return { ...state, loading: false, info: action.payload }
        }
        case ChargePackageActionTypes.SET_PAYMENT_TYPE: {
            return { ...state, type: action.payload }
        }
        case ChargePackageActionTypes.SET_TRANSACTION_STATUS: {
            return { ...state, status: action.payload }
        }
        default:
            return state
    }
}

export { reducer as chargePackageReducer }